import { render, staticRenderFns } from "./fndisclouser.vue?vue&type=template&id=5b6f080e&"
import script from "./fndisclouser.vue?vue&type=script&lang=js&"
export * from "./fndisclouser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports